import {
	CATALOG_TILE_IMAGE_SPECS,
	DESIGN_IMAGE_COMMON,
	HERO_SLIDE_IMAGE_SPECS,
	PUBLICATION_COVER_IMAGE_SPEC,
} from "../homepage_hero/heroSlideImageSpecs";

function SpecBlock({ spec }) {
	return (
		<div className="rounded-[12px] border border-darkBlue/10 bg-white/90 p-4">
			<h3 className="font-Vazir-700 text-[14px] text-darkBlue">{spec.title}</h3>
			<ul className="mt-2 space-y-1.5 font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/75">
				<li>
					<span className="font-Vazir-600 text-darkBlue">پیشنهادی:</span>{" "}
					{spec.recommended}
				</li>
				<li>
					<span className="font-Vazir-600 text-darkBlue">حداقل:</span> {spec.minimum}
				</li>
				<li>
					<span className="font-Vazir-600 text-darkBlue">نسبت:</span> {spec.ratio}
				</li>
				<li>{spec.display}</li>
			</ul>
		</div>
	);
}

export default function ImageGuidelinesContent({ compact = false }) {
	const { common } = HERO_SLIDE_IMAGE_SPECS;
	const sectionTitle = compact
		? "font-Vazir-700 text-[13px] text-darkBlue"
		: "font-Vazir-700 text-[14px] text-darkBlue";

	return (
		<div className="flex flex-col gap-4">
			<p className="font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/60">
				استاندارد طراحی همراهتیم برای آپلود تصویر در پنل مدیریت.
			</p>

			<div>
				<p className={sectionTitle}>اسلایدر صفحه اصلی</p>
				<div
					className={[
						"mt-2 grid gap-2",
						compact ? "grid-cols-1" : "md:grid-cols-2",
					].join(" ")}
				>
					<SpecBlock spec={HERO_SLIDE_IMAGE_SPECS.desktop} />
					<SpecBlock spec={HERO_SLIDE_IMAGE_SPECS.mobile} />
				</div>
				<ul className="mt-2 space-y-1 font-Vazir-400 text-[11px] text-darkBlue/55">
					<li>{common.crop}</li>
					<li>{common.text}</li>
				</ul>
			</div>

			<div>
				<p className={sectionTitle}>کلیپ، کارگاه، وبینار</p>
				<div className="mt-2 flex flex-col gap-2">
					<SpecBlock spec={CATALOG_TILE_IMAGE_SPECS.clip} />
					<SpecBlock spec={CATALOG_TILE_IMAGE_SPECS.workshop} />
					<SpecBlock spec={CATALOG_TILE_IMAGE_SPECS.webinar} />
				</div>
				<p className="mt-2 font-Vazir-400 text-[11px] text-darkBlue/55">
					{DESIGN_IMAGE_COMMON.catalogCrop}
				</p>
			</div>

			<div>
				<p className={sectionTitle}>مقاله</p>
				<div className="mt-2">
					<SpecBlock spec={PUBLICATION_COVER_IMAGE_SPEC} />
				</div>
				<p className="mt-2 font-Vazir-400 text-[11px] text-darkBlue/55">
					{DESIGN_IMAGE_COMMON.publicationCrop}
				</p>
			</div>

			<p className="font-Vazir-400 text-[11px] text-darkBlue/50">
				{DESIGN_IMAGE_COMMON.format}
			</p>
		</div>
	);
}
